module.exports = __webpack_public_path__ + "img/result-footer.5cf6075f.png";